export default __webpack_public_path__ + "0e7fd4867156e874102bba56530b6d45.svg";